"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.34 6.4c.361 0 .655.291.655.65l.005 7.3c0 .36-.293.652-.655.652h-3.784v-1H15L14.995 7.4h-4.269v4.506h.001v1h-.001v2.098H4.952a.5.5 0 0 1-.5-.5v-1.598H2.725a.5.5 0 0 1-.5-.5v-1.8H.5a.5.5 0 0 1-.5-.5V2.65C0 2.291.294 2 .656 2h10.232c.361 0 .654.291.654.65v.676h-1V3H6.554l1.478 1.301h5.081c.361 0 .654.292.654.65l.002 1.448h1.571ZM2.225 4.952v4.651H1V3h4.04l1.478 1.301H2.88a.654.654 0 0 0-.655.652Zm2.227 2.904V7.04c0-.31.363-.64.655-.64h3.794L7.654 5.301H3.225v6.604h1.227V7.857ZM10.415 6.4 9.168 5.301h3.6l.001 1.098h-2.354Zm-.689 5.506v2.098H5.452V7.4h4.274v4.506Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.184 8.953c.445 0 .807.36.807.8L24 20.881a.806.806 0 0 1-.808.802h-5.767v-1.142h5.431l-.008-10.445H20.6v.001h-4.637v11.015h-.003v.571H7.355a.572.572 0 0 1-.572-.571v-2.625H3.961a.572.572 0 0 1-.571-.571V14.98H.57a.572.572 0 0 1-.57-.57V3.052c0-.442.362-.802.808-.802H16.4c.444 0 .806.36.806.8v1.031h-1.143v-.688H9.29l2.686 2.364h7.815c.444 0 .806.358.806.8l.002 2.396h2.585ZM3.39 6.56v7.278H1.143V3.393H7.56l2.686 2.364H4.198a.806.806 0 0 0-.808.802Zm3.393 10.785V9.756c0-.443.363-.803.809-.803h6.285L11.544 6.9H4.532v10.444h2.251Zm8.825-8.39L13.274 6.9h6.18l.002 2.053h-3.848Zm-.787 8.39h-.001v3.197H7.927V10.096h6.895v7.248Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M30.912 11.938c.593 0 1.076.478 1.076 1.067L32 27.84c0 .59-.484 1.07-1.078 1.07h-7.688v-1.524h7.241l-.011-13.925h-9.179V28.15h-.006v.761H9.806a.762.762 0 0 1-.762-.762v-3.5H5.282a.762.762 0 0 1-.762-.761v-3.915H.762a.762.762 0 0 1-.762-.76V4.069C0 3.479.483 3 1.077 3h20.79c.593 0 1.075.479 1.075 1.067v1.374H21.42v-.917h-9.033l3.582 3.152h10.42c.593 0 1.074.478 1.075 1.066l.002 3.196h3.447ZM4.52 8.745v9.705H1.524V4.524h8.556l3.582 3.152H5.598c-.595 0-1.078.48-1.078 1.07Zm4.524 14.38V13.009c0-.59.484-1.07 1.078-1.07h8.381L15.393 9.2h-9.35v13.926h3.001ZM20.81 11.939 17.7 9.2h8.24l.002 2.738h-5.13Zm-1.05 11.188v4.261h-9.192V13.462h9.193v9.664Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M46.563 18.023c.782 0 1.419.631 1.419 1.407L48 41.876c0 .779-.638 1.412-1.423 1.412H34.946v-1.89H46.11l-.017-21.485H31.787v15.036h.003v1.89h-.003v4.559h.001v1.89H14.631a.945.945 0 0 1-.945-.945v-5.504H7.784a.945.945 0 0 1-.945-.945v-6.13H.945A.945.945 0 0 1 0 28.82V5.91C0 5.133.638 4.5 1.423 4.5h31.455c.782 0 1.419.631 1.419 1.407v2.08h-1.89V6.39H17.982l5.892 5.185h15.843c.782 0 1.419.63 1.419 1.406l.003 5.042h5.424ZM6.839 12.985v14.89h-4.95V6.39h13.233l5.891 5.185H8.261c-.784 0-1.422.633-1.422 1.41Zm6.847 21.964V19.433c0-.777.637-1.41 1.421-1.41H28.34l-5.179-4.558H8.728v21.484h4.958Zm17.513-16.926-5.179-4.558h13.227l.003 4.558H31.2ZM29.898 34.95h-.003v1.89h.003v4.559H15.575V36.84h.004v-1.89h-.004V19.913h14.323v15.036Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M62.084 24.03c1.043 0 1.892.842 1.892 1.876L64 55.836a1.89 1.89 0 0 1-1.897 1.88H46.594v-2.519H61.48l-.023-28.647H42.383V46.6h.004v2.519h-.004v6.078h.001v2.52H19.507a1.26 1.26 0 0 1-1.26-1.26V49.12h-7.869a1.26 1.26 0 0 1-1.26-1.26v-8.173H1.26A1.26 1.26 0 0 1 0 38.426V7.881A1.89 1.89 0 0 1 1.897 6h41.94c1.044 0 1.892.841 1.892 1.876v2.773h-2.52V8.52H23.977l7.856 6.915h21.124c1.043 0 1.891.84 1.891 1.874l.005 6.723h7.232ZM9.118 17.314v19.853H2.52V8.52h17.643l7.855 6.914H11.015a1.891 1.891 0 0 0-1.897 1.88Zm9.13 29.286V25.911c0-1.037.85-1.88 1.895-1.88h17.642l-6.905-6.078H11.638V46.6h6.61Zm23.351-22.568-6.905-6.078h17.635l.004 6.078H41.599ZM39.863 46.6h-.004v2.52h.004v6.078H20.767V49.12h.004V46.6h-.004V26.551h19.096v20.048Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconBundle = function IconBundle(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Bundle' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Bundle"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconBundle.sizes = [16, 24, 32, 48, 64];
IconBundle.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconBundle;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/products/Bundle.js
// module id = 2231
// module chunks = 0